// the `FusionCheck` need the element value to handle validate
// but any custom component has not the proto param
export default {
  inserted: function (el, { value }) {
    el.value = value
  },
  update: function (el, { value }) {
    el.value = value
  },
}
